import { Icon } from '@livable/saas-react-components';
import { Button, Checkbox, Chip, FormControlLabel, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import RequestToUseCustomAddress from 'src/components/shared/RequestToUseCustomAddress';
import { RESIDENCY_ADDRESS_STATUS } from 'src/constants/residency';
import { useStore } from 'src/stores';
import useEnrollResidentStyles from './styles';
export const CustomAddress = observer(_ref => {
  let defaultAddress = _ref.defaultAddress;
  const classes = useEnrollResidentStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Mailing addresses"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Address that is used for all paper communications (Invites & Statements)."), /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressList
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItemWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItemCheck
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: store.residencies.customAddresses.findIndex(i => i.isPrimary) === -1,
      onClick: e => e.stopPropagation()
    }),
    onChange: () => {
      store.residencies.makesPropertyAddressAsPrimary();
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItemDetails
  }, /*#__PURE__*/React.createElement("span", null, "Property address"), /*#__PURE__*/React.createElement("b", null, defaultAddress)), /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItemControllers
  }, /*#__PURE__*/React.createElement(Chip, {
    label: store.residencies.customAddresses.findIndex(i => i.isPrimary) > -1 ? 'Backup' : 'Primary',
    variant: store.residencies.customAddresses.findIndex(i => i.isPrimary) > -1 ? 'inactive' : 'success'
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    size: "small",
    disabled: true,
    'custom-attribute': '235-EnrollResident'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('general.edit'))))), store.residencies.customAddresses.map(i => {
    var _i$details;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItem
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemWrapper
    }, i.status !== RESIDENCY_ADDRESS_STATUS.pending && /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemCheck
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: i.isPrimary,
        onClick: e => e.stopPropagation()
      }),
      onChange: () => {
        store.residencies.changePrimaryPropertyAddress(i);
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemDetails
    }, /*#__PURE__*/React.createElement("span", null, "Address"), /*#__PURE__*/React.createElement("b", null, "".concat(i.details.street, " ").concat(i.details.city, ", ").concat(i.details.state, " ").concat(i.details.zip).concat((_i$details = i.details) !== null && _i$details !== void 0 && _i$details.secondary ? ', ' + i.details.secondary : ''))), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemControllers
    }, /*#__PURE__*/React.createElement(Chip, {
      label: i.isPrimary ? 'Primary' : 'Backup',
      variant: i.isPrimary ? 'success' : 'inactive'
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemDetailsActions
    }, /*#__PURE__*/React.createElement(RequestToUseCustomAddress, {
      dumb: true,
      data: i
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "menuAction",
      size: "small",
      onClick: () => {
        store.residencies.removePropertyAddresses(i.addressId);
      },
      'custom-attribute': '237-EnrollResident'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    }), t('Remove'))))));
  })), /*#__PURE__*/React.createElement(RequestToUseCustomAddress, {
    dumb: true
  }));
});